import {
  CanActivateFn,
  Router,
  UrlTree
} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '../api/auth/auth.service';
import {LoggerService} from '../api/logging/logger.service';
import {
  ChecklistService
} from '../api/checkList/checklist.service';
import {
  AppConfigService
} from '../config/app-config.service';
import {
  PostHogService
} from '../api/posthog/posthog.service';

const FLAG_TIMEOUT_MS = 2000;
const EXPERIMENT_FLAG = 'landing-page-test';

export const redirectFirstVisitToLanding:
  CanActivateFn =
  async (): Promise<boolean | UrlTree> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const logger = inject(LoggerService);
    const checklistService =
      inject(ChecklistService);
    const appConfig = inject(AppConfigService);
    const postHog = inject(PostHogService);

    logger.info('Evaluating first vistit conditions');
    if (!appConfig.isMobile) {
      logger.info('Not mobile');
      return true;
    }

    if (authService.isLoggedIn()) {
      logger.info('Logged in');
      return true;
    }

    if (checklistService.hasExistingUser()) {
      logger.info('Existing user');
      return true;
    }

    if (!postHog.isInitialised()) {
      logger.info(
        'First visit: PostHog not initialised,'
        + ' defaulting to landing page'
      );
      return router.createUrlTree(['/landing']);
    }

    await postHog.waitForFlags(FLAG_TIMEOUT_MS);
    const variant =
      postHog.getFeatureFlag(EXPERIMENT_FLAG);

    logger.info(
      'First visit: experiment variant='
      + String(variant)
    );

    if (variant === 'control') {
      return true;
    }

    return router.createUrlTree(['/landing']);
  };
